export default __webpack_public_path__ + "static/media/correctAnswerWide.a3db9abd.svg";